import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

import Content, { HTMLContent } from '../components/Content'

const Product = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1rem;
  padding: 2em 6em;
  background-color: rgba(222, 222, 222, 0.25);
  @media screen and (max-width: 1080px) {
    padding: 2em 2em;
  }
  p {
    color: #777;
    text-align: left;
    margin-bottom: 30px;
  }
  img {
    width: 100%;
  }
  iframe {
    align-self: center;
  }
  div {
    margin-top: 30px;
  }
`

const ProductPageTemplate = ({
  title,
  description,
  index,
  content,
  contentComponent,
}) => {
  const PageContent = contentComponent || Content
  return (
    <Product id={`product${index}`} key={title}>
      <h2>{title}</h2>
      {description && <p>{description}</p>}
      <PageContent content={content} />
    </Product>
  )
}

export { ProductPageTemplate }

const ProductPage = ({ html, frontmatter }) => {
  return (
    <ProductPageTemplate
      {...frontmatter}
      content={html}
      contentComponent={HTMLContent}
    />
  )
}

export default ProductPage



// WEBPACK FOOTER //
// ./src/templates/product-page.js